module.exports = __webpack_public_path__ + "static/media/Version.7b847a07.svg";